import {
    SuperBit_swaggerClient,
    FilterDataModel,
    SystemManagementModel,
    RiderServiceModel,
} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

// Service wrapper for the System Management "Rider services" tab.
// Replaces the old MVC Views/SystemManagement/Riders/_RiderServices.cshtml view
// (+ _RiderServicesItems.cshtml, _NewRiderService.cshtml, _UpdateRiderService.cshtml)
// and the RiderController endpoints the old systemManagement.js posted to
// (Rider/GetService -> riderGetService, Rider/UpsertService -> riderUpsertService,
//  Rider/DeleteService -> riderDeleteService). The sorted/searched list comes from
// riderSortService, which returns the whole SystemManagementModel (the rider
// services plus the rider companies that form the dynamic grid columns).
export class RiderServicesModel {
    client: any;

    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        const url = apiUrl ? apiUrl : generalSettings.apiUrl;

        // Some generated client methods omit the Authorization header; inject it
        // here (only when absent) so every call through this client is authenticated.
        // Same shim BranchesModel / RidersModel use.
        const authHttp = {
            fetch(input: RequestInfo, init?: RequestInit) {
                const token = localStorage.getItem('AuthToken');
                const headers: any = { ...(init && init.headers ? init.headers : {}) };
                if (token && !headers['Authorization']) {
                    headers['Authorization'] = `Bearer ${token}`;
                }
                return window.fetch(input, { ...(init || {}), headers });
            },
        };

        this.client = new SuperBit_swaggerClient(url, authHttp);
    }

    // Sorted/searched list of rider services (replaces _RiderServicesItems.cshtml).
    // The server applies the optional SearchTerm and sortBy and returns the full
    // SystemManagementModel; riderServices are the rows and riderComapnies are the
    // dynamic per-company columns. The server does NOT paginate this list.
    async sortServices(filter: FilterDataModel): Promise<SystemManagementModel> {
        return await this.client.riderSortService(filter);
    }

    // Loads a service for editing (id set) OR a fresh service for adding (id
    // undefined). Either way the returned model carries AllComapnies (the company
    // inputs the add/edit form binds to) and the existing RiderServiceCompanies.
    async getService(id?: string): Promise<RiderServiceModel> {
        return await this.client.riderGetService(id);
    }

    // Create AND edit both post through riderUpsertService (the server upserts by
    // Id), mirroring the old form which always posted to Rider/UpsertService.
    async upsertService(model: RiderServiceModel): Promise<void> {
        return await this.client.riderUpsertService(model);
    }

    async deleteService(id: string): Promise<void> {
        return await this.client.riderDeleteService(id);
    }
}
